import { Box, Stack, Typography } from "@mui/material";

import { IconFile } from "@/assets/icons";
import { black, orange } from "@/theme/colors";

type Props = {
  filename: string;
  height?: number;
};

export const OfficeFilePreview = ({ filename, height = 530 }: Props) => (
  <Stack alignItems="center" justifyContent="center" height={height} spacing={2} sx={{ width: "100%" }}>
    <Box sx={{ fontSize: 64, color: black[60], display: "flex" }}>
      <IconFile />
    </Box>
    <Typography
      variant="body14"
      color={black[60]}
      sx={{ wordBreak: "break-all", textAlign: "center", maxWidth: 400, px: 2 }}
    >
      {filename}
    </Typography>
    <Typography variant="cap12" color={orange[70]} sx={{ textAlign: "center", maxWidth: 400, px: 2 }}>
      PDF以外のファイルはプレビューに対応していません。
    </Typography>
  </Stack>
);
